import { createStore } from 'vuex'

import axios from "axios"
import { CONFIG } from "@/config.js"
import router from "@/router.js"
import locales from '@/locales'

const api = axios.create({
  baseURL: CONFIG.api.baseUrl,
  withCredentials: true,
  withXSRFToken: true,
  xsrfHeaderName: "X-CSRFTOKEN",
  xsrfCookieName: "csrftoken_new"
});

api.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response && [401, 403].some(code => code == error.response.status)) {
      router.push({ name: "login" })
    }

    return Promise.reject(error)
  }
)

// Create a new store instance.
const store = createStore({
  state() {
    return {
      api: api,
      user: {},
      permissions: [],
      gatehouses: [],
      selectedGatehouse: null,
      notificationCount: 0,
      copyRecord: null,
    }
  },
  getters: {
    api: function (state) {
      return state.api;
    },
    isLoggedIn: function (state) {
      return Object.keys(state.user).length != 0;
    },
    user: function (state) {
      return state.user;
    },
    language: function (state) {
      return state.language;
    },
    languages: function (state) {
      return state.languages;
    },
    gatehouses: function (state) {
      return state.gatehouses;
    },
    selectedGatehouse: function (state) {
      return state.selectedGatehouse;
    },
    hasPerm: (state) => (perm) => {
      return state.permissions.includes(perm);
    },
    hasGatehousePerm: (state) => (perm) => {
      if (!state.selectedGatehouse) {
        return false
      }
      return state.selectedGatehouse.permissions.includes(perm);
    },
    getCopyRecord: (state) => {
      return state.copyRecord;
    },
  },
  mutations: {
    getUserProfile(state) {
      state.api.get("/auth/user").then(response => {
        const data = response.data.user;
        store.commit("saveUserProfile", data);
      });
    },
    saveUserProfile(state, data) {
      state.permissions = data.permissions;
      delete data.permissions;
      state.gatehouses = data.gatehouses;
      if (!state.selectedGatehouse && state.gatehouses.length) {
        state.selectedGatehouse = state.gatehouses[0]
      }
      delete data.gatehouses;
      state.user = data;
    },
    selectGatehouse(state, slug) {
      for(var i = 0; i < state.gatehouses.length; i++){
        if (state.gatehouses[i].slug == slug){
          state.selectedGatehouse = state.gatehouses[i]
        }
      }
    },
    addGatehouse(state, gatehouse) {
      state.gatehouses.push(gatehouse)
    },
    removeGatehouse(state, slug) {
      state.gatehouses = state.gatehouses.filter(g => g.slug !== slug)
    },
    setNotificationCount(state, value) {
      state.notificationCount = value;
    },
    setCopyRecord(state, obj) {
      state.copyRecord = obj;
    },
    clearCopyRecord(state) {
      state.copyRecord = null;
    },
  },
});


export default store;